<script>
import { Line } from "vue-chartjs";
import MethodService from "../../../service/MethodService";
import mushroom from "viettoc-api";
export default {
  extends: Line,
  data() {
    return {
      labels: [],
      datas: [],
    };
  },
  methods: {
    async fn_initData() {
      let dataFilter = {
        fields: "thoi_diem_tao",
        sort: "thoi_diem_tao",
        limit: 9999,
      };
      try {
        const response = await mushroom.dong_ho.listAsync(dataFilter);
        let resData = await this.fn_changeData(response.result);
        let arrDate = [];
        resData.forEach((item, index) => {
          arrDate.push(item.thoi_diem_tao);
        });
        this.labels = [...new Set(arrDate)];
        const map = arrDate.reduce(
          (acc, e) => acc.set(e, (acc.get(e) || 0) + 1),
          new Map()
        );
        let arr = [...map.values()];
        let count = 0;
        for (let i = 0; i < arr.length; i++) {
          count = count + arr[i];
          this.datas.push(count);
        }
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    fn_changeData(data) {
      data.forEach((element) => {
        element.thoi_diem_tao = MethodService.formatDate(
          element.thoi_diem_tao,
          "date"
        );
      });
      //
      return data;
    },
  },
  async mounted() {
    await this.fn_initData();
    this.gradient = this.$refs.canvas
      .getContext("2d")
      .createLinearGradient(500, 0, 100, 0);
    this.gradient2 = this.$refs.canvas
      .getContext("2d")
      .createLinearGradient(1000, 0, 600, 0);

    this.gradient.addColorStop(0, "#80b6f4");
    this.gradient.addColorStop(1, "#f49080");

    this.gradient2.addColorStop(0, "rgba(128, 182, 244, 0.6)");
    this.gradient2.addColorStop(1, "rgba(244, 144, 128, 0.6)");

    this.renderChart(
      {
        labels: this.labels,
        datasets: [
          {
            label: "Số lượng dòng họ",
            data: this.datas,
            // backgroundColor: this.gradient,

            // borderColor: this.gradient,
            // borderColor: this.gradient2,
            // pointBackgroundColor: "#f04950",

            borderColor: this.gradient,
            pointBorderColor: this.gradient,
            pointBackgroundColor: this.gradient,
            pointHoverBackgroundColor: this.gradient,
            pointHoverBorderColor: this.gradient,
            pointBorderWidth: 4,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 1,
            pointRadius: 3,
            fill: true,
            backgroundColor: this.gradient2,
            borderWidth: 3,
          },
        ],
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          // text: "Số lượng dòng họ",
        },
      }
    );
  },
};
</script>
